import { useState, useEffect, useRef } from 'react'
import {AnimatePresence, motion} from 'framer-motion'
import { useSelector, useDispatch } from 'react-redux'
// css
import './css/slidecomponent.css'
import './css/slide1.css'
// components
import Skill0 from "./Skill0"
import Skill1 from "./Skill1"
import Skill2 from "./Skill2"
import Skill3 from "./Skill3"
//Actions
import { incrementSkillCounter, decrementSkillCounter} from '../reducers/ActionsCreator'


const Slide_1 = ({ counter }) => { 
	const dispatch = useDispatch()
	const skillsReducer = useSelector(state => state.SkillsReducer)
	let slide1Ref = useRef(null)
	
	const nextSkill = () => {
		if(skillsReducer.counter === 3 ) return
			dispatch(incrementSkillCounter())
	}
	const prevSkill = () => {
		if(skillsReducer.counter === 0) return
			dispatch(decrementSkillCounter())
	}

	return(
		<AnimatePresence>
			{counter === 1 &&
			<motion.div 
				key="slide_components_1key0"
					initial={{opacity:0}}
					animate={{opacity:1}}
					transition={{duration:2}}
					exit={{opacity:0}}
				className="slide_components" id="slide_components_1" 
				ref={slide1Ref}
				>
				<div className="skills_railway_container">
					<button id="next_skill" onClick={nextSkill}><i className={skillsReducer.counter===3?"fas fa-chevron-right chevron_fade":"fas fa-chevron-right"}></i></button>

					<AnimatePresence>
					{skillsReducer.counter===0&&<Skill0 skillCounter={skillsReducer.counter} animatinDir={skillsReducer.dir}/>}

					{skillsReducer.counter===1&&<Skill1 skillCounter={skillsReducer.counter} animatinDir={skillsReducer.dir}/>}

					{skillsReducer.counter===2&&<Skill2 skillCounter={skillsReducer.counter} animatinDir={skillsReducer.dir}/>}

					{skillsReducer.counter===3&&<Skill3 skillCounter={skillsReducer.counter} animatinDir={skillsReducer.dir}/>}
					</AnimatePresence>

					<button id="prev_skill" onClick={prevSkill}><i className={skillsReducer.counter===0?"fas fa-chevron-left chevron_fade":"fas fa-chevron-left"}></i></button>
				</div>					
			</motion.div>
			}
		</AnimatePresence>
		)
}

export default Slide_1